export const constResultGridCols = Object.freeze({
    candidateName : 'Candidate Name',
    candidateGender : 'Gender',
    candidateAge : 'Age',
    partyName : 'Party Name',
    partySymbol : 'Symbol',
    candidateTotalVotesPolled : 'Total Votes Polled',
    candidatePercentValidVotesPolled : 'Votes %',
});